import { CheckCircle2, Save } from "lucide-react";
import { useState } from "react";
import { API } from "../../data/siteData";

const statusOptions = ["new", "reviewing", "contacted", "confirmed", "declined", "closed"];

function BriefingRequestItem({ request, onSaved }) {
  const [status, setStatus] = useState(request.status);
  const [note, setNote] = useState(request.internal_note || "");
  const [state, setState] = useState("idle");

  const save = async () => {
    setState("loading");
    const response = await fetch(`${API}/admin/briefing-requests/${request.briefing_id}`, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status, internal_note: note }),
    });
    if (!response.ok) {
      setState("error");
      return;
    }
    await onSaved();
    setState("saved");
  };

  return <article className="briefing-queue-item" data-testid={`briefing-request-${request.briefing_id}`}><div><span>{request.briefing_type}</span><h3>{request.full_name}</h3><p>{request.company || "Independent"} · {request.email}</p><p>{request.topic}</p>{request.message && <p>{request.message}</p>}</div><div className="briefing-admin-controls"><label>Status<select value={status} onChange={(event) => setStatus(event.target.value)} data-testid={`briefing-status-${request.briefing_id}`}>{statusOptions.map((option) => <option key={option} value={option}>{option}</option>)}</select></label><label>Internal coordination note<textarea value={note} onChange={(event) => setNote(event.target.value)} data-testid={`briefing-note-${request.briefing_id}`} /></label>{state === "error" && <p className="form-error" data-testid={`briefing-error-${request.briefing_id}`}>Update failed.</p>}{state === "saved" && <p className="upload-message" data-testid={`briefing-saved-${request.briefing_id}`}><CheckCircle2 size={14} />Saved</p>}<button className="icon-button" type="button" title="Save briefing request" onClick={save} disabled={state === "loading"} data-testid={`save-briefing-${request.briefing_id}`}><Save size={16} /></button></div></article>;
}

export default function BriefingQueue({ requests, onRefresh }) {
  return <section className="admin-section" data-testid="admin-briefing-queue"><div><span className="eyebrow">Executive coordination</span><h2>BRIEFING REQUESTS</h2></div>{!requests.length && <div className="empty-state" data-testid="briefing-queue-empty-state">No executive briefing requests yet.</div>}<div className="briefing-queue-list" data-testid="briefing-queue-list">{requests.map((request) => <BriefingRequestItem key={request.briefing_id} request={request} onSaved={onRefresh} />)}</div></section>;
}